import React, { useState, useRef, useEffect } from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import DownArrow from '../core/fiesta-icons/DownArrow';

const DROPDOWN_WIDTH = 240;

function useOutsideClick(ref, isOpen, onClose) {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen, ref, onClose]);
}

const EventToolbarInfoButton = ({
  label,
  icon,
  color = '#ffffff',
  shouldDisplayLabel = false,
  onPress,
  children,
  isDisabled,
  isOpen: controlledIsOpen,
  onToggle,
}) => {
  const isControlled = controlledIsOpen !== undefined;
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const isOpen = isControlled ? controlledIsOpen : uncontrolledOpen;

  const [offset, setOffset] = useState({ top: 0, right: 0 });
  const parentRef = useRef(null);
  const menuRef = useRef(null);
  const { width } = useWindowSize();
  const isLabelVisible = shouldDisplayLabel && width >= 768;

  const setIsOpen = (value) => {
    if (isControlled) {
      onToggle?.(value);
    } else {
      setUncontrolledOpen(value);
    }
  };

  const showMenu = (e) => {
    e.preventDefault();
    const rect = parentRef.current.getBoundingClientRect();
    const leftDiff = rect.right - DROPDOWN_WIDTH;
    if (leftDiff < 0) {
      setOffset({ top: 0, right: leftDiff });
    }
    setIsOpen(true);
  };

  useOutsideClick(parentRef, isOpen, () => setIsOpen(false));

  const renderIcon = () => {
    return isLabelVisible ? <DownArrow /> : icon;
  };

  const btnStyles = {
    color,
    stroke: color,
    borderColor: isLabelVisible && color,
  };

  if (children) {
    return (
      <li className="lgtoolbar__dropdown lgdropdown" ref={parentRef}>
        <button
          className={['lgtoolbar__btn', isLabelVisible && 'lgtoolbar__btn--with-label'].filter(Boolean).join(' ')}
          onClick={showMenu}
          title={label}
          aria-haspopup="true"
          aria-expanded={isOpen}
          style={btnStyles}
          disabled={isDisabled}
        >
          <span className={!isLabelVisible && 'sr-only'}>{label}</span>
          {renderIcon()}
        </button>

        <div
          className={['lgdropdown__menu', !isOpen && 'visuallyhidden'].filter(Boolean).join(' ')}
          style={offset}
          ref={menuRef}
        >
          {children}
        </div>
      </li>
    );
  }

  return (
    <li>
      <button
        disabled={isDisabled}
        className={['lgtoolbar__btn', isLabelVisible && 'lgtoolbar__btn--with-label'].filter(Boolean).join(' ')}
        onClick={onPress}
        title={label}
        style={btnStyles}
      >
        <span className={!isLabelVisible && 'sr-only'}>{label}</span>
        {renderIcon()}
      </button>
    </li>
  );
};

export default EventToolbarInfoButton;
